import DynamicPageRenderer from "../../components/DynamicPageRenderer";

const ElHadjiMalickSy = () => {
  return <DynamicPageRenderer slug="histoire/el-hadji-malick-sy" />;
};

export default ElHadjiMalickSy;
